import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const forceScrollTop = () => {
  if (typeof window === "undefined") return;
  window.scrollTo(0, 0);
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  const targets = [
    document.scrollingElement,
    document.documentElement,
    document.body,
    document.getElementById("root"),
  ].filter(Boolean);
  targets.forEach((target) => {
    target.scrollTop = 0;
    target.scrollLeft = 0;
  });
};

const isInternalNavigationClick = (event) => {
  if (event.defaultPrevented || event.button !== 0) return false;
  if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) return false;
  const anchor = event.target?.closest?.("a[href]");
  if (!anchor) return false;
  const href = anchor.getAttribute("href") || "";
  if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return false;
  if (anchor.target && anchor.target !== "_self") return false;
  try {
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    return true;
  } catch (_) {
    return href.startsWith("/");
  }
};

export default function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const handleClick = (event) => {
      if (!isInternalNavigationClick(event)) return;
      forceScrollTop();
      window.requestAnimationFrame(forceScrollTop);
      window.setTimeout(forceScrollTop, 0);
      window.setTimeout(forceScrollTop, 120);
    };
    document.addEventListener("click", handleClick, true);
    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);

  useLayoutEffect(() => {
    forceScrollTop();
  }, [pathname, search, hash, key]);

  useEffect(() => {
    forceScrollTop();
    const frameId = window.requestAnimationFrame(forceScrollTop);
    const timeoutIds = [0, 50, 120, 250, 500, 900, 1400, 2200, 3500].map((delay) =>
      window.setTimeout(forceScrollTop, delay)
    );
    const intervalId = window.setInterval(forceScrollTop, 120);
    const stopIntervalId = window.setTimeout(() => window.clearInterval(intervalId), 1800);
    return () => {
      window.cancelAnimationFrame(frameId);
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
      window.clearInterval(intervalId);
      window.clearTimeout(stopIntervalId);
    };
  }, [pathname, search, hash, key]);

  return null;
}
